$(window).resize(function() {
    window_width = $(window).innerWidth();
    window_height = $(window).innerHeight();
})



const hidePreloader = () => {
    $("#preloader").fadeOut(1000, function() {
        $(this).hide();
    });
};

$(document).ready(function() {

    if ($('.b-article').length) {
        $('header').addClass('line-bot');
    }

    $(".tooltip").on('click', '.tooltip-btn', function() {
        var cont = $(this).next().clone();
        if ($(window).innerWidth() < 1025) {
            $.fancybox.open({
                src: '#modal',
                speed: 500,
                touch: false,
                autoFocus: false,
                closeExisting: true,
                hideScrollbar: true,
                smallBtn: false,
                toolbar: false,
                animationEffect: "zoom-in-out",
                opts: {
                    beforeShow: function(instance, current) {
                        cont.appendTo(".modal-cont");
                    },
                    afterShow: function(instance, current) {
                        hold_scroll_page(true);
                    },
                    afterClose: function(instance, current) {
                        hold_scroll_page(false);
                        $(".modal-cont > *").remove();
                    }
                },
            });
        }
    });


    $(".swiper-slide .test-block .form-group:last-child input[type='number']").on('change input', function() {
        if ($(this).val() !== "" && $(".swiper-slide .test-block .form-group:nth-last-child(2) input[type='number']").val() !== "") {
            $(".b-test .next-btn").css('pointer-events', 'all').css('opacity', '1');
        } else {
            $(".b-test .next-btn").css('pointer-events', 'none').css('opacity', '0.5');
        }
    });
    $(".swiper-slide .test-block .form-group:nth-last-child(2) input[type='number']").on('change input', function() {
        if ($(this).val() !== "" && $(".swiper-slide .test-block .form-group:last-child input[type='number']").val() !== "") {
            $(".b-test .next-btn").css('pointer-events', 'all').css('opacity', '1');
        } else {
            $(".b-test .next-btn").css('pointer-events', 'none').css('opacity', '0.5');
        }
    });

    $(".swiper-slide .test-block .form-group input[type='number']").on('keypress', function() {
        if (this.value.length > 2) { return false; }
    });

    /*document.querySelector('.swiper-slide input[type="text"]').addEventListener('keyup', function(){
        this.value = this.value.replace(/[^\d]/g, '');
    });*/

    if ($('.b-test').length) {
        let name = document.querySelector('.swiper-slide input[type="number"]');
        let regex = /[^\d]/g;

        name.oninput = function() {
            this.value = this.value.replace(regex, '');
        }
    }

    // end ready
});

var windowLoad = false;
$(window).load(function() {
    windowLoad = true;

    setTimeout(() => {
        $('.anim').each(function() {
            $(this).addClass('start_anim');
        });
        $(window).trigger('resize');

    }, 2000);

    setTimeout(() => {
        if (windowLoad) {
            hidePreloader();
        }
    }, 300);
});


function getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
}




function setBodyClass() {
    if (!document.querySelector('[data-body="o_"]')) return false;
    let body = document.body;
    body.classList.add('o_');
}
setBodyClass();


function actionBlock(el, arrow) {
    if (!document.querySelector(el)) return;
    let parent = document.querySelector(el);
    let trigOpen = parent.querySelectorAll('[data-action="open"]');
    let trigClose = parent.querySelectorAll('[data-action="close"]');
    trigOpen.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            let atrs = trigger.dataset.elName;
            let elem = parent.querySelector(`[data-name=${atrs}]`);

            if (!elem) return;
            if (arrow) {
                let prevEl = e.target.closest('.block').previousElementSibling;
                let arr = prevEl.querySelector(arrow);
                arr.style.zIndex = 0;
            }
            elem.classList.add('show');
        });
    });
    trigClose.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            let atrs = trigger.dataset.elName;
            let elem = parent.querySelector(`[data-name=${atrs}]`);
            if (!elem) return;
            if (arrow) {
                let prevEl = e.target.closest('.block').previousElementSibling;
                let arr = prevEl.querySelector(arrow);
                arr.removeAttribute('style');
            }
            elem.classList.remove('show');
        });
    });

}

function init_AOS() {
    if (!document.querySelector('[data-aos="fade-down"]')) return false;
    AOS.init({
        delay: 300,
        duration: 500,
        once: true,
        anchorPlacement: 'center-center',
        offset: 0,
        easing: 'linear'
    });
}

document.addEventListener('DOMContentLoaded', () => {
    init_AOS();
});
window.onload = function() {
    actionBlock('.blame_diabetes', '.arrow');
}